export const emptyBpCreationState = {
  bp: {}
}
